module.exports = {
      id: "vikatan-play-logo-red-usage",
      viewBox: "0 0 536.066 789.439",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#vikatan-play-logo-red",
      toString: function () {
        return this.url;
      }
    }